<template>
  <el-radio-group v-model="computedValue" :disabled="!editable">
    <div
      v-for="item in config.options"
      :key="item.baseQuestionOptionId"
      class="radio-item-wrap"
    >
      <el-radio :label="String(item.baseQuestionOptionId)">{{
        item.baseQuestionOptionName
      }}</el-radio>
    </div>
  </el-radio-group>
</template>

<script>
import CompMix from "../../mixins/comp-mix";
export default {
  mixins: [CompMix],
};
</script>

<style lang="scss" scoped>
.radio-item-wrap {
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
}
::v-deep .el-radio {
  display: flex !important;
  align-items: center;
  .el-radio__label {
    display: inline-block;
    white-space: break-spaces;
    line-height: 20px;
  }
}
</style>
